import { useMemo, useRef } from "react"
import Dialog from "@mui/material/Dialog"
import DialogContent from "@mui/material/DialogContent"
import DialogActions from "@mui/material/DialogActions"
import Button from "@mui/material/Button"
import Grid from "@mui/material/Grid"
import Typography from "@mui/material/Typography"
import Box from "@mui/material/Box"
import { useReactToPrint } from "react-to-print"
import bill from "assets/images/1bill.jpg"
import alfalah from "assets/images/alfa.png"
import nbp from "assets/images/nbp.jpg"
import hbl from "assets/images/hbl-c.png"
import ubllogo from "assets/images/ubl_new.png"
import bzuLogo from "assets/images/BZU-logo.png"
import QRCode from "react-qr-code"
import { buildBzuVoucherQrStringFromVoucher } from "utils/buildBzuVoucherQrString"

const formatVoucherDate = (value) => {
  if (!value) return ""
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return String(value)
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric",
    timeZone: "Asia/Karachi",
  })
}

const DetailRow = ({ label, value, bold = false }) => (
  <Grid container>
    <Grid item xs={4} sx={{ borderRight: "1px solid #000", borderBottom: "1px solid #000", p: 0.25 }}>
      <Typography variant="body2" fontSize="10px" fontWeight={bold ? "bold" : "regular"}>
        {label}
      </Typography>
    </Grid>
    <Grid item xs={8} sx={{ borderBottom: "1px solid #000", p: 0.25 }}>
      <Typography variant="body2" fontSize="10px" fontWeight={bold ? "bold" : "regular"}>
        {value || ""}
      </Typography>
    </Grid>
  </Grid>
)

const RegistrarVoucherSection = ({ title, images, voucher, qrValue }) => (
  <Box sx={{ border: "1px solid #000", p: 0.25, height: "100%", fontSize: "10px" }}>
    <Grid container>
      <Grid item xs={12}>
        <Grid container>
          <Grid item xs={3} sx={{ borderRight: "1px solid #000", borderBottom: "1px solid #000", p: 0.25, textAlign: "center" }}>
            <Typography variant="body2" fontSize="12px" fontWeight="bold">
              {title}
            </Typography>
          </Grid>
          <Grid item xs={9} sx={{ borderBottom: "1px solid #000", p: 0.25, textAlign: "center" }}>
            <Typography variant="body2" fontSize="12px">
              Voucher no: <strong>{voucher.challan_no}</strong>
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Grid container sx={{ borderBottom: "1px solid #000" }}>
          <Grid item xs={3} sx={{ borderRight: "1px solid #000", p: 0.25, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Box component="img" src={images.bill} alt="1BILL" sx={{ height: 35, maxWidth: "100%" }} />
          </Grid>
          <Grid item xs={9} sx={{ p: 0.25, textAlign: "center" }}>
            <Typography variant="body2" fontSize="10px" fontWeight="bold">
              All Mobiles Banking Channels
            </Typography>
            <Typography variant="body2" fontSize="10px">
              1 Bill Inv. ID/Consumer No.
            </Typography>
            <Typography variant="body2" fontSize="10px" fontWeight="bold">
              1016205150{voucher.challan_no}
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Grid container sx={{ borderBottom: "1px solid #000" }}>
          <Grid item xs={3} sx={{ borderRight: "1px solid #000", p: 0.25, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Box component="img" src={images.ubl} alt="UBL" sx={{ height: 30, maxWidth: "90%" }} />
          </Grid>
          <Grid item xs={9} sx={{ p: 0.25, textAlign: "center" }}>
            <Typography variant="body2" fontSize="10px" fontWeight="bold">
              BZU Registrar Fee
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Grid container sx={{ borderBottom: "1px solid #000" }}>
          <Grid item xs={3} sx={{ borderRight: "1px solid #000", p: 0.25, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Box component="img" src={images.alfalah} alt="Bank Alfalah" sx={{ height: 40, maxWidth: "100%" }} />
          </Grid>
          <Grid item xs={9} sx={{ p: 0.25, textAlign: "center" }}>
            <Typography variant="body2" fontSize="10px">
              To be posted in <strong>Alfalah Transact</strong> via <strong>Fee Collection tab</strong> (API)
            </Typography>
            <Typography variant="body2" fontSize="10px" fontWeight="bold">
              BAHAUDDIN ZAKARIYA UNIVERSITY MULTAN
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Grid container sx={{ borderBottom: "1px solid #000" }}>
          <Grid item xs={3} sx={{ borderRight: "1px solid #000", p: 0.25, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Box component="img" src={images.nbp} alt="NBP" sx={{ height: 20, maxWidth: "100%" }} />
          </Grid>
          <Grid item xs={9} sx={{ p: 0.25, textAlign: "center" }}>
            <Typography variant="body2" fontSize="10px" fontWeight="bold">
              Collection Via NBP CMS
            </Typography>
            <Typography variant="body2" fontSize="10px" fontWeight="bold">
              BZU Registrar Fee
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Grid container sx={{ borderBottom: "1px solid #000" }}>
          <Grid item xs={3} sx={{ borderRight: "1px solid #000", p: 0.25, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Box component="img" src={images.hbl} alt="HBL" sx={{ height: 30, maxWidth: "100%" }} />
          </Grid>
          <Grid item xs={9} sx={{ p: 0.25, textAlign: "center" }}>
            <Typography variant="body2" fontSize="10px" fontWeight="bold">
              Pay digitally through
            </Typography>
            <Typography variant="body2" fontSize="10px" fontWeight="bold">
              HBL / Konnect App or Konnect Agent
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Grid container sx={{ borderBottom: "1px solid #000" }}>
          <Grid item xs={3} sx={{ borderRight: "1px solid #000", p: 0.25, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Box component="img" src={images.bzuLogo} alt="BZU Logo" sx={{ height: 60, maxWidth: "100%" }} />
          </Grid>
          <Grid item xs={9} sx={{ p: 0.25, textAlign: "center" }}>
            <Typography variant="body2" fontSize="13px" fontWeight="bold">
              Bahauddin Zakariya University, Multan
            </Typography>
            <Typography variant="body2" fontSize="13px" fontWeight="bold">
              (PAKISTAN)
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} sx={{ bgcolor: "#000", color: "#fff", p: 0.25, textAlign: "center" }}>
        <Typography variant="body2" fontSize="10px" fontWeight="bold">
          {voucher.label || "Registrar Voucher"}
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Box sx={{ width: "100%", textAlign: "center" }}>
          <DetailRow label="Issue Date" value={formatVoucherDate(voucher.print_date)} />
          <DetailRow label="Student Name" value={voucher.name} />
          <DetailRow label="Father Name" value={voucher.father_name} />
          <DetailRow label="CNIC" value={voucher.cnic} />
          <DetailRow label="Phone" value={voucher.phone} />
          <DetailRow label="Student ID" value={voucher.student_id} />
          <DetailRow label="Roll No" value={voucher.roll_no} />
          <DetailRow label="Session" value={voucher.session} />
          <DetailRow label="Fees Payable" value={`PKR ${voucher.amount}/-`} bold />
          <Grid container>
            <Grid item xs={12} sx={{ borderBottom: "1px solid #000", p: 0.25, textAlign: "center" }}>
              <Typography variant="body2" fontSize="10px" fontWeight="bold">
                <i>{voucher.amount_in_words}</i>
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Grid>

      <Grid item xs={12} sx={{ textAlign: "center", p: 0.5, borderBottom: "1px solid #000" }}>
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", minHeight: 108, bgcolor: "#fff" }}>
          {qrValue ? (
            <>
              <QRCode value={qrValue} size={100} level="L" bgColor="#FFFFFF" fgColor="#000000" style={{ height: 100, width: 100 }} />
              <Typography variant="body2" sx={{ fontSize: "8px", mt: 0.25 }}>
                Scan to Pay
              </Typography>
            </>
          ) : null}
        </Box>
      </Grid>

      <Grid item xs={12} sx={{ p: 0.25, borderBottom: "1px solid #000", textAlign: "center" }}>
        <Typography variant="body2" fontSize="10px">
          This Challan is Valid up to <strong>{formatVoucherDate(voucher.due_date)}</strong>
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Grid container>
          <Grid item xs={6} sx={{ borderRight: "1px solid #000", p: 0.25, textAlign: "center" }}>
            <Typography variant="body2" fontSize="10px">
              Sign Officer
            </Typography>
          </Grid>
          <Grid item xs={6} sx={{ p: 0.25, textAlign: "center" }}>
            <Typography variant="body2" fontSize="10px">
              Sign Cashier
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  </Box>
)

function RegistrarVoucherPrintDialog({ open, onClose, voucher }) {
  const printRef = useRef()
  const images = { bill, alfalah, nbp, ubl: ubllogo, hbl, bzuLogo }

  const qrValue = useMemo(() => {
    if (!voucher?.challan_no) return ""
    try {
      return buildBzuVoucherQrStringFromVoucher(voucher)
    } catch (error) {
      console.error("Failed to build registrar voucher QR string:", error)
      return ""
    }
  }, [voucher])

  const printRegistrarVoucher = useReactToPrint({
    content: () => printRef.current,
    documentTitle: `Registrar-Voucher-${voucher?.challan_no || ""}`,
  })

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
      <DialogContent>
        <Box ref={printRef} sx={{ p: 0.5 }}>
          <Grid container spacing={0.5}>
            {["Department", "Student", "BZU, Multan", "Bank"].map((title) => (
              <Grid item sm={3} key={title}>
                <RegistrarVoucherSection title={title} images={images} voucher={voucher || {}} qrValue={qrValue} />
              </Grid>
            ))}
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
        <Button onClick={printRegistrarVoucher} color="primary" variant="contained" style={{ color: "white" }}>
          Print Voucher
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default RegistrarVoucherPrintDialog
